"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chart = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactChartjs = require("react-chartjs-2");

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _chart = require("chart.js");

var _excluded = ["id", "type", "onHeightChange", "options"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

_chart.Chart.register(_chart.CategoryScale, _chart.LinearScale, _chart.BarElement, _chart.Title, _chart.Tooltip, _chart.Legend, _chart.PointElement, _chart.LineElement, _chart.PieController, _chart.ArcElement, _chart.DoughnutController, _chart.RadarController, _chart.RadialLinearScale, _chart.BubbleController, _chart.ScatterController);

var Chart = function Chart(props) {
  var id = props.id,
      type = props.type,
      onHeightChange = props.onHeightChange,
      options = props.options,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var mergedOptions = (0, _react.useMemo)(function () {
    return (0, _lodash.default)({
      indexAxis: type === 'horizontalBar' ? 'y' : 'x',
      plugins: {
        legend: {
          labels: {
            font: {
              size: 10
            }
          }
        }
      }
    }, options);
  }, [options, type]);
  var ChartComponent = (0, _react.useMemo)(function () {
    return {
      line: _reactChartjs.Line,
      doughnut: _reactChartjs.Doughnut,
      pie: _reactChartjs.Pie,
      bar: _reactChartjs.Bar,
      horizontalBar: _reactChartjs.Bar,
      radar: _reactChartjs.Radar,
      bubble: _reactChartjs.Bubble,
      scatter: _reactChartjs.Scatter
    }[type];
  }, [type]);
  var innerId = (0, _react.useMemo)(function () {
    return id || "id-".concat(Math.round(Math.random() * 1e9)); // eslint-disable-next-line
  }, [ChartComponent]);
  /*
   type changing lead to component redraw
   at some moment component could have zero height
   to avoid scroll jumping because of that
   fixing height of chart container could be needed
  */

  (0, _react.useEffect)(function () {
    var chart = document.getElementById(innerId);
    var height = Number.parseFloat(window.getComputedStyle(chart).height);
    onHeightChange(height);
  }, [innerId, onHeightChange]);
  return /*#__PURE__*/_react.default.createElement(ChartComponent, (0, _extends2.default)({
    id: innerId,
    options: mergedOptions
  }, rest));
};

exports.Chart = Chart;
var type = ['line', 'doughnut', 'pie', 'bar', 'horizontalBar', 'radar', 'bubble', 'scatter'];
Chart.modes = {
  type: type
};
Chart.propTypes = {
  /* component logic props */
  type: (0, _propTypes.oneOf)(type),
  onHeightChange: _propTypes.func,
  options: _propTypes.object,
  id: _propTypes.string
};
Chart.defaultProps = {
  type: 'line',
  onHeightChange: function onHeightChange() {},
  options: {},
  id: null
};